"use client";

import { useEffect } from "react";
import { usePageLocaleContext } from "@/app/context/PageLocaleContext";

type Props = {
  sourceSlug: string;
  slugs: Record<string, string>;
};

/**
 * Invisible leaf rendered by the CMS page route (`/pages/[slug]`) that registers the
 * current page's cross-language slug map into PageLocaleContext, so the global Header's
 * language switcher can resolve the correct target-language URL for this exact page
 * instead of blindly reusing the current slug. Clears its registration on unmount so a
 * stale mapping never survives a client-side navigation to a different page.
 */
export function PageLocaleRegistrar({ sourceSlug, slugs }: Props) {
  const { setPageLocale } = usePageLocaleContext();
  const slugsKey = JSON.stringify(slugs);

  useEffect(() => {
    setPageLocale({ sourceSlug, slugs: JSON.parse(slugsKey) });
    return () => setPageLocale(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceSlug, slugsKey]);

  return null;
}
